import styled from "styled-components";
import Responsive from "../media-queries";
import { LinkButton } from "../link-button";
import YoungVetsClubImage from "../../images/young-vets-club-button.png";
import YoungVetsClubMonkeyImage from "../../images/young-vets-club-monkey.png";

const SubMenuWrapper = styled.div`
  display: none;

  ${Responsive.lg} {
    background: ${(props) => props.theme.colours.tertiary};
    color: ${(props) => props.theme.colours.white};
    display: flex;
    justify-content: center;
    padding: 10px;
    text-align: center;
    transition: all 250ms ease;
    width: 100%;
  }
`;

const SubMenuContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  max-width: 1200px;
  padding: 0 ${(props) => props.theme.layout.gutter.md};
  position: relative;
  width: 1200px;
`;

const YoungVetsClubLink = styled.a`
  position: absolute;
  top: -10px;
  right: 0;
  width: 165px;

  &:after {
    background: url(${YoungVetsClubMonkeyImage}) 0 0 no-repeat;
    background-size: 100px auto;
    content: "";
    height: 110px;
    opacity: 0;
    position: absolute;
    right: 30px;
    top: 10px;
    transition: opacity 250ms ease, top 250ms ease, visibility 250ms ease;
    visibility: hidden;
    width: 100px;
    z-index: 0;
  }

  &:hover:after {
    opacity: 1;
    top: 30px;
    visibility: visible;
  }
`;

const YoungVetsClubImg = styled.img`
  position: relative;
  width: 100%;
  z-index: 5;
`;

export const SubMenu = (props) => {
  return (
    <SubMenuWrapper>
      <SubMenuContainer>
        <YoungVetsClubLink
          href="https://www.youngvetsclub.com/"
          rel="noopener noreferrer"
          target="_blank"
          title="Young Vets Club"
        >
          <YoungVetsClubImg alt="Young Vets Club" src={YoungVetsClubImage} />
        </YoungVetsClubLink>
        <LinkButton
          size="small"
          style={{ margin: "0 150px 0 0" }}
          targetBlank
          title="WVS Shop"
          to="https://wvsshop.org.uk/"
        >
          WVS Shop
        </LinkButton>
      </SubMenuContainer>
    </SubMenuWrapper>
  );
};
